(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bgm-article-language"] && !Shopify.designMode) return;
  try {
    class BgmArticleLanguage extends HTMLElement {
 setupArtist(body,nav){
  const jp=/[\u3040-\u30ff\u3400-\u9fff]/;
  const clean=e=>(e.textContent||'').replace(/\s+/g,' ').trim();
  const mediaSelector='img,iframe,video,audio';
  const groups=[[]];
  const collect=el=>{for(const n of [...el.childNodes]){
   if(n.nodeType===1&&n.matches('div,section,article')&&n.querySelector('h2,h3,h4')){collect(n);continue}
   if(n.nodeType===1&&n.matches('hr')){if(groups.at(-1).length)groups.push([]);continue}
   groups.at(-1).push(n);
  }};
  collect(body);
  const updates=[],fragment=document.createDocumentFragment();
  for(const nodes of groups){
   if(!nodes.some(n=>clean(n)||n.nodeType===1&&(n.matches(mediaSelector)||n.querySelector(mediaSelector))))continue;
   const section=document.createElement('section');section.className='artist-blog-update';
   const ja=document.createElement('div'),en=document.createElement('div');
   ja.lang='ja';en.lang='en';ja.className=en.className='artist-blog-copy';
   let language='ja';
   for(const n of nodes){
    if(n.nodeType===1&&n.matches('h2,h3,h4')&&clean(n)){
     if(jp.test(clean(n)))language='ja';
     else if(/[a-z]{3}/i.test(clean(n)))language='en';
    }
    (language==='ja'?ja:en).append(n);
   }
   const hasBoth=jp.test(clean(ja))&&/[a-z]{3}/i.test(clean(en));
   const moves=[];
   if(hasBoth){
    const enMedia=[...en.querySelectorAll(mediaSelector)].map(m=>m.getAttribute('src'));
    const englishSlot=document.createElement('div');englishSlot.className='artist-blog-media-group';
    const heading=en.querySelector('h2,h3,h4');
    let anchor=heading;
    const next=heading?.nextElementSibling;
    if(next&&/^(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[A-Z]*\b.*\b\d{4}\b/i.test(clean(next))&&clean(next).length<100)anchor=next;
    if(anchor)anchor.after(englishSlot);else en.prepend(englishSlot);
    for(const media of [...ja.querySelectorAll(mediaSelector)]){
     if(enMedia.includes(media.getAttribute('src')))continue;
     let unit=media;
     while(unit.parentElement!==ja&&unit.parentElement&&!clean(unit.parentElement)&&!unit.parentElement.querySelector('h2,h3,h4'))unit=unit.parentElement;
     if(moves.some(m=>m.unit.contains(unit)))continue;
     const slot=document.createElement('span');slot.className='artist-blog-media-slot';
     unit.before(slot);moves.push({unit,slot,englishSlot});
    }
   }
   for(const copy of [ja,en]){
    for(const p of [...copy.querySelectorAll('p')])if(!clean(p)&&!p.querySelector(mediaSelector)&&!p.querySelector('.artist-blog-media-slot'))p.remove();
   }
   if(ja.childNodes.length)section.append(ja);
   if(en.childNodes.length)section.append(en);
   updates.push({ja,en,hasBoth,moves});fragment.append(section);
  }
  body.replaceChildren(fragment);body.classList.add('artist-blog-body');
  const select=lang=>{
   for(const update of updates){
    update.ja.hidden=update.hasBoth&&lang==='en';update.en.hidden=update.hasBoth&&lang==='ja';
    for(const m of update.moves){if(lang==='en')m.englishSlot.append(m.unit);else m.slot.after(m.unit)}
   }
   nav.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.selectLanguage===lang)));
   this.dataset.selectedLanguage=lang;
  };
  if(updates.some(u=>u.hasBoth)){
   nav.hidden=false;nav.setAttribute('role','group');nav.setAttribute('aria-label','記事の言語 / Article language');
   nav.addEventListener('click',e=>{const button=e.target.closest('[data-select-language]');if(button){select(button.dataset.selectLanguage);try{sessionStorage.setItem('artist-blog-language',button.dataset.selectLanguage)}catch(error){}}});
   let lang=document.documentElement.lang.startsWith('en')?'en':'ja';
   
   select(lang);
  }
 }

 connectedCallback(){
  if(this.ready)return;this.ready=true;if(document.documentElement.lang.startsWith('en')&&['569870155966','569392496830'].includes(this.dataset.articleId))return;
  if(this.querySelector('[data-native-language]')){
   const current=new URL(window.location.href);
   if(current.searchParams.has('preview_key'))this.querySelectorAll('[data-native-language] a').forEach(a=>{const target=new URL(a.href);target.pathname=target.pathname.replace(/\/[^/]+$/, '/articles');target.search=current.search;a.href=target.href;});
   return;
  }
  const body=this.querySelector('[data-article-body]'),nav=this.querySelector('[data-article-switch]');
  if(!body||!nav)return;
  if(this.hasAttribute('data-artist-blog')){this.setupArtist(body,nav);return;}
  const jp=/[\u3040-\u30ff\u3400-\u9fff]/;
  const clean=e=>(e.textContent||'').replace(/\s+/g,' ').trim();
  const blocks=[];
  const walk=el=>{for(const n of [...el.childNodes]){if(n.nodeType===3){if(n.textContent.trim()){const span=document.createElement('span');n.replaceWith(span);span.append(n);blocks.push(span)}continue}if(n.nodeType!==1)continue;if(n.matches('div,section,article')&&n.querySelector('p,h1,h2,h3,h4,h5,h6,ul,ol'))walk(n);else if(!n.matches('script,style,meta'))blocks.push(n)}};
  walk(body);
  const explicit=blocks.find(x=>/^English version below/i.test(clean(x)));
  const letter=blocks.find(x=>/^(Monthly Letter\s*#01|Hi, this is Chiai Nagano, shop owner\.)/i.test(clean(x)));
  const boundary=explicit||letter;
  let language='ja',ja=0,en=0;
  const originalOnly=this.dataset.articleId==='567764353214';
  for(let i=0;i<blocks.length;i++){
   const b=blocks[i],t=clean(b);
   if(b===boundary)language='en';
   if(!boundary&&!originalOnly&&b.matches('h2,h3,h4')&&t){
    const next=blocks.slice(i+1).find(x=>clean(x)&&!x.matches('hr'));
    language=jp.test(t)||(next&&jp.test(clean(next)))?'ja':'en';
   }
   if(originalOnly){if(/^This is a repost of a blog article/.test(t))language='en';if(t==='Original Blog')language='shared'}
   let value=language;
   if(!boundary&&(!t||b.matches('iframe,video,audio')||/^(LINKS|Access|Web)$/i.test(t)))value='shared';
   const media=b.matches('img,iframe,video,audio')?b:b.querySelector('img,iframe,video,audio');
   if(media){const src=media.getAttribute('src');if(src&&[...body.querySelectorAll('img,iframe,video,audio')].filter(m=>m.getAttribute('src')===src).length>1)value=language;}
   if(b.matches('hr'))value='marker';
   if(b===explicit)value='marker';
   b.dataset.articleLanguage=value;
   if(value==='ja'&&jp.test(t))ja++;
   if(value==='en'&&/[a-z]{3}/i.test(t))en++;
  }
  if(!ja||!en){for(const b of blocks)delete b.dataset.articleLanguage;return}
  const select=lang=>{for(const b of blocks)b.hidden=!['shared',lang].includes(b.dataset.articleLanguage);nav.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.selectLanguage===lang)));this.dataset.selectedLanguage=lang;};
  nav.addEventListener('click',e=>{const b=e.target.closest('[data-select-language]');if(b)select(b.dataset.selectLanguage)});
  nav.hidden=false;select(document.documentElement.lang.startsWith('en')?'en':'ja');
 }
}
if(!customElements.get('bgm-article-language'))customElements.define('bgm-article-language',BgmArticleLanguage);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bgm-card-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bgm-card-preview')) {
 document.addEventListener('play', event => {
  if (!(event.target instanceof HTMLMediaElement)) return;
  document.querySelectorAll('audio').forEach(audio => { if(audio !== event.target) audio.pause(); });
 }, true);
 const waveObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
  entries.forEach(entry => {
   if(entry.isIntersecting){entry.target.drawWave?.();waveObserver.unobserve(entry.target);}
  });
 }, {rootMargin:'300px'}) : null;
 customElements.define('bgm-card-preview', class extends HTMLElement {
  connectedCallback() {
   if(this.controller) return;
   this.controller = new AbortController();
   const signal = this.controller.signal;
   ['pointerdown','mousedown','touchstart','click','focusin'].forEach(type => this.addEventListener(type, event => event.stopPropagation(), {signal}));
   this.audio = this.querySelector('audio');
   const audio = this.audio, button = this.querySelector('button'), seek = this.querySelector('input'), error = this.querySelector('.bgmc-error');
   const data = this.querySelector('[data-peaks]');
   this.drawWave = () => {
   const peaks = data ? JSON.parse(data.dataset.peaks) : [];
   const scale = Number(data?.dataset.waveScale || 1);
   const heights = peaks.map(p=>Math.max(.25,Number(p)/scale*30));
   const upper=heights.map((h,i)=>`${(i*960/(peaks.length-1)).toFixed(2)},${(32-h).toFixed(2)}`);
   const lower=heights.map((h,i)=>`${(i*960/(peaks.length-1)).toFixed(2)},${(32+h).toFixed(2)}`).reverse();
   const path=peaks.length>1?'M'+upper.join('L')+'L'+lower.join('L')+'Z':'M0 31.75H960V32.25H0Z';
   this.querySelectorAll('path').forEach(p=>p.setAttribute('d',path));
   this.drawWave = null;
   };
   if(waveObserver) waveObserver.observe(this); else this.drawWave();
   let pendingSeek=null;
   ['pointerdown','mousedown'].forEach(type => button.addEventListener(type, event => {
    if(event.button!==0) return;
    event.preventDefault();
   }, {signal}));
   let seekPointer=null;
   const seekAt = event => {
    const rect=seek.getBoundingClientRect();
    if(!rect.width) return;
    seek.value=String(Math.max(0,Math.min(100,(event.clientX-rect.left)/rect.width*100)));
    seek.dispatchEvent(new Event('input',{bubbles:true}));
   };
   seek.addEventListener('pointerdown', event => {
    if(!event.isPrimary || event.button!==0) return;
    event.preventDefault();
    event.stopPropagation();
    seekPointer=event.pointerId;
    seek.setPointerCapture(event.pointerId);
    seekAt(event);
   }, {signal});
   seek.addEventListener('pointermove', event => {
    if(seekPointer!==event.pointerId) return;
    event.stopPropagation();
    seekAt(event);
   }, {signal});
   ['pointerup','pointercancel','lostpointercapture'].forEach(type => seek.addEventListener(type,event=>{
    if(seekPointer!==event.pointerId) return;
    event.stopPropagation();
    seekPointer=null;
   },{signal}));
   const format=t=>Math.floor(t/60)+':'+String(Math.floor(t%60)).padStart(2,'0');
   const paint = () => {
    const playing = !audio.paused && !audio.ended;
    button.setAttribute('aria-pressed', String(playing));
    button.setAttribute('aria-label', (playing ? this.dataset.pause : this.dataset.play) + ': ' + this.dataset.title);
    this.querySelector('[data-icon]').textContent = playing ? 'Ⅱ' : '▶';
    this.querySelector('[data-label]').textContent = playing ? this.dataset.pause : this.dataset.play;
    const duration=Number.isFinite(audio.duration)?audio.duration:Number(data?.dataset.duration||0);
    const time=pendingSeek!==null?pendingSeek*duration:(audio.currentTime||0);
    this.querySelector('[data-time]').textContent=format(time)+(duration?' / '+format(duration):'');
    seek.value=duration?time/duration*100:0;
    this.querySelector('.bgmc-progress').style.clipPath=`inset(0 ${100-Number(seek.value)}% 0 0)`;
   };
   button.addEventListener('click', async () => {
    error.hidden = true;
    if (!audio.paused) {audio.pause(); return;}
    if (!audio.getAttribute('src')) audio.src = this.dataset.url;
    if (audio.ended) audio.currentTime = 0;
    try {await audio.play();} catch(e) {if(e.name !== 'AbortError'){error.textContent = this.dataset.error; error.hidden = false;} paint();}
   }, {signal});
   seek.addEventListener('input', () => {
    const fraction=Number(seek.value)/100;
    if(Number.isFinite(audio.duration)) audio.currentTime=fraction*audio.duration;
    else {pendingSeek=fraction;if(!audio.getAttribute('src')){audio.src=this.dataset.url;audio.load();}}
    paint();
   }, {signal});
   audio.addEventListener('loadedmetadata',()=>{if(pendingSeek!==null){audio.currentTime=pendingSeek*audio.duration;pendingSeek=null;}paint();},{signal});
   ['play','pause','ended','timeupdate','loadedmetadata'].forEach(name=>audio.addEventListener(name,paint,{signal}));
   audio.addEventListener('error',()=>{error.textContent=this.dataset.error;error.hidden=false;paint();},{signal});
   paint();
  }
  disconnectedCallback(){waveObserver?.unobserve(this);this.drawWave=null;this.controller?.abort();this.controller=null;this.audio?.pause();}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bgm-image-title-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();
  function setup() {
    document.querySelectorAll('scroll-carousel.product-list').forEach(list => {
      if (initialized.has(list) || !list.querySelector('.home-note-slot')) return;
      initialized.add(list);
      const stableHeight = Boolean(list.closest('[id$="__bgm_bestsellers"]'));
      let frame;
      const update = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const bounds = list.getBoundingClientRect();
          if (!bounds.width) return;
          const cards = Array.from(list.querySelectorAll('.home-music-card'));
          let height = 0;
          cards.forEach(card => {
            const box = card.getBoundingClientRect();
            const overlap = Math.min(box.right, bounds.right) - Math.max(box.left, bounds.left);
            if (!stableHeight && overlap < box.width * .5) return;
            const image = card.querySelector('.product-card__image');
            if (image) {
              const ratio = Number(image.getAttribute('width')) / Number(image.getAttribute('height'));
              const fraction = parseFloat(card.style.getPropertyValue('--bgm-art-width')) / 100 || 1;
              if (ratio > 0) height = Math.max(height, box.width * fraction / ratio);
            }
          });
          if (height > 0) {
            const rows = Math.ceil(height) + 'px auto auto auto';
            if (list.style.gridTemplateRows !== rows) list.style.gridTemplateRows = rows;
          }
        });
      };
      if (!stableHeight) list.addEventListener('scroll', update, {passive:true});
      list.addEventListener('load', update, true);
      let previousWidth = -1;
      new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width === previousWidth) return;
        previousWidth = width;
        update();
      }).observe(list);
      update();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bgm-inside-frame"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const button=event.target.closest('.bgm-inside__language');
  if(!button)return;
  const panel=button.closest('.bgm-inside');
  const english=panel.dataset.language!=='en';
  panel.dataset.language=english?'en':'ja';
  button.textContent=english?'EN / JP':'JP / EN';
  button.setAttribute('aria-pressed',String(english));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bgm-library"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bgm-library')) {
  customElements.define('bgm-library', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.labels = JSON.parse(this.dataset.labels);
      this.audio = this.querySelector('audio');
      this.rows = Array.from(this.querySelectorAll('[data-track]'));
      this.playable = this.rows.filter(row => row.dataset.url);
      this.current = null;
      this.revision = 0;
      this.playRequest = 0;
      this.wantsPlayback = false;
      this.playbackFailed = false;
      this.retryCount = 0;
      this.recoveryTimer = null;
      this.status = this.querySelector('.bgml-status');
      this.dock = this.querySelector('.bgml-dock');
      this.tracks = this.querySelector('.bgml-tracks');
      const layoutQuery = matchMedia('(max-width:749px)');
      const syncDirections = () => {
        const horizontal = layoutQuery.matches && !!this.closest('bgm-library-browser');
        const en = document.documentElement.lang.startsWith('en');
        for (const selector of ['[data-prev]', '[data-next]']) {
          const button = this.querySelector(selector);
          button.textContent = horizontal ? button.textContent.replace('↑','←').replace('↓','→') : button.textContent.replace('←','↑').replace('→','↓');
        }
        this.querySelectorAll('.bgml-help kbd').forEach((key,index) => {
          key.textContent = horizontal ? ['←','→'][index] : ['↑','↓'][index];
          key.setAttribute('aria-label', horizontal ? (en ? ['Left arrow','Right arrow'] : ['左矢印','右矢印'])[index] : (en ? ['Up arrow','Down arrow'] : ['上矢印','下矢印'])[index]);
        });
        this.tracks.setAttribute('aria-label', en ? (horizontal ? 'Tracks: left/right to select, space to play or pause' : 'Tracks: up/down to select, space to play or pause') : (horizontal ? '曲一覧：左右キーで選曲・再生、スペースキーで再生・停止' : '曲一覧：上下キーで選曲・再生、スペースキーで再生・停止'));
      };
      syncDirections();
      layoutQuery.addEventListener('change',syncDirections,{signal});
      this.registerRows(this.rows);
      this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1), {signal});
      this.querySelector('[data-toggle]').addEventListener('click', () => this.toggle(), {signal});
      this.querySelector('[data-now]').addEventListener('click', () => this.reveal(), {signal});
      this.tracks.addEventListener('keydown', event => {
        if (event.target !== this.tracks || event.altKey || event.metaKey || event.ctrlKey) return;
        const horizontal = this.isHorizontal();
        if (horizontal ? event.key === 'ArrowRight' || event.key === 'ArrowLeft' : event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          this.move((event.key === 'ArrowDown' || event.key === 'ArrowRight') ? 1 : -1, undefined, event.repeat);
          this.reveal();
        } else if (event.code === 'Space' || event.key === ' ') {
          event.preventDefault();
          if (!this.current && this.playable[0]) this.select(this.playable[0], true);
          else this.toggle();
        }
      }, {signal});
      document.addEventListener('keydown', event => {
        if (event.defaultPrevented || event.altKey || event.metaKey || event.ctrlKey || event.shiftKey || event.isComposing) return;
        const horizontal = this.isHorizontal();
        if (horizontal ? event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' : event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        if (!this.current || (!this.wantsPlayback && !this.playbackFailed && this.audio.paused)) return;
        const target = event.target;
        if (!(target instanceof Element) || target.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="slider"], [role="combobox"], [role="listbox"], [role="menu"], [role="dialog"], dialog, .drawer, .popover')) return;
        event.preventDefault();
        this.move((event.key === 'ArrowDown' || event.key === 'ArrowRight') ? 1 : -1, undefined, event.repeat);
        this.reveal();
      }, {signal});
      this.querySelectorAll('[data-view-button]').forEach(button => button.addEventListener('click', () => this.setView(button.dataset.viewButton), {signal}));
      try {this.setView(sessionStorage.getItem('bgml-view')||'list')} catch {this.setView('list')}
      this.audio.addEventListener('loadedmetadata', () => {
        if (this.pendingSeek != null && Number.isFinite(this.audio.duration)) {
          this.audio.currentTime = this.audio.duration * this.pendingSeek;
          this.pendingSeek = null;
        }
        if (this.current) this.paint(this.current, this.audio.currentTime, this.audio.duration);
      }, {signal});
      this.audio.addEventListener('timeupdate', () => {
        if (this.current) this.paint(this.current, this.audio.currentTime, this.audio.duration);
        if (!this.audio.paused && this.audio.readyState >= 3 && this.audio.currentTime > 0) this.clearRecovery();
      }, {signal});
      this.audio.addEventListener('play', () => this.syncButtons(), {signal});
      this.audio.addEventListener('playing', () => {
        if (!this.wantsPlayback) { this.audio.pause(); return; }
        this.clearRecovery();
        this.playbackFailed = false;
        this.status.textContent = '';
        this.syncButtons();
      }, {signal});
      ['waiting', 'stalled'].forEach(type => this.audio.addEventListener(type, () => {
        if (!this.wantsPlayback || !this.current || this.audio.readyState >= 3) return;
        this.status.textContent = this.labels.loading + ': ' + this.current.dataset.title;
        this.armRecovery();
      }, {signal}));
      this.audio.addEventListener('pause', () => this.syncButtons(), {signal});
      this.audio.addEventListener('error', () => {
        if (!this.current || !this.audio.error) return;
        this.recover(this.revision);
      }, {signal});
      this.audio.addEventListener('ended', () => {
        if (!this.audio.ended) return;
        this.pausePlayback();
        this.syncButtons();
        if (this.querySelector('[data-autoplay]').checked) this.move(1, true);
      }, {signal});
      document.addEventListener('play', event => {
        if (event.target instanceof HTMLMediaElement && event.target !== this.audio) this.pausePlayback();
      }, {capture:true, signal});
    }
    mountRecords(records) {
      const key = records.map(record => record.dataset.trackId).join(',');
      if (key === this.pageKey) return;
      this.pageKey = key;
      this.rowController?.abort();
      this.rowController = new AbortController();
      this.pausePlayback();this.current=null;this.dock.hidden=true;
      const make=(tag,cls,text)=>{const el=document.createElement(tag);if(cls)el.className=cls;if(text!=null)el.textContent=text;return el};
      this.rows=records.map((record,index)=>{
        const row=make('article','bgml-row');row.setAttribute('data-track','');Object.assign(row.dataset,record.dataset);
        const art=make('a','bgml-art');art.href=record.href;art.setAttribute('aria-label',record.dataset.title);
        if(record.image){const img=make('img');img.src=record.image;img.alt='';img.loading=index===0?'eager':'lazy';img.width=640;img.height=640;art.append(img)}
        const info=make('div','bgml-info'),title=make('a','bgml-title',record.dataset.title);title.href=record.href;info.append(title);
        const meta=make('div','bgml-meta');if(record.bpm)meta.append(make('span','',`BPM ${record.bpm}`));info.append(meta);
        const pills=make('div','bgml-pills');for(const [group,values] of [['genre',record.genres],['mood',record.moods]])for(const value of values){if(!value)continue;const a=make('a','bgml-pill bgml-pill-'+group,document.documentElement.lang.startsWith('en')&&value==='キラキラ'?this.labels.shimmering:value);a.href=(document.documentElement.lang.startsWith('en')?'/en':'')+'/collections/all?filter.p.m.custom.'+group+'_filter='+encodeURIComponent(value);pills.append(a)}info.append(pills);
        if(record.note){const note=document.createElement('template');note.innerHTML=record.note;info.append(note.content.cloneNode(true))}
        const listen=make('div','bgml-listen');
        if(record.dataset.url){
          const play=make('button','bgml-play');play.type='button';play.dataset.play='';play.setAttribute('aria-label',this.labels.play+': '+record.dataset.title);const icon=make('span','');icon.setAttribute('aria-hidden','true');icon.innerHTML="<svg aria-hidden=\"true\" viewBox=\"0 0 24 24\" width=\"22\" height=\"22\" fill=\"currentColor\"><path d=\"M7 4v16l13-8z\"/></svg>";play.append(icon);listen.append(play);
          const wave=make('div','bgml-wave');const data=make('span');data.hidden=true;data.dataset.peaks=JSON.stringify(record.peaks);data.dataset.duration=record.dataset.duration;data.dataset.waveScale=record.scale||255;wave.append(data);
          const ns='http://www.w3.org/2000/svg',svg=document.createElementNS(ns,'svg');svg.setAttribute('viewBox','0 0 960 64');svg.setAttribute('preserveAspectRatio','none');svg.setAttribute('aria-hidden','true');const defs=document.createElementNS(ns,'defs'),gradient=document.createElementNS(ns,'linearGradient');const gradientId='bgml-sunset-'+this.id+'-'+record.dataset.trackId;gradient.id=gradientId;for(const [offset,color] of [['0%','#e59a38'],['55%','#ed7945'],['100%','#e35a59']]){const stop=document.createElementNS(ns,'stop');stop.setAttribute('offset',offset);stop.setAttribute('stop-color',color);gradient.append(stop)}defs.append(gradient);svg.append(defs);for(const cls of ['bgml-wave-base','bgml-wave-progress']){const path=document.createElementNS(ns,'path');path.setAttribute('class',cls);if(cls==='bgml-wave-progress')path.style.fill='url(#'+gradientId+')';svg.append(path)}wave.append(svg);
          const seek=make('input');seek.type='range';seek.min=0;seek.max=100;seek.step=.1;seek.value=0;seek.dataset.seek='';seek.setAttribute('aria-label',this.labels.seek+': '+record.dataset.title);wave.append(seek);listen.append(wave);
          const time=make('span','bgml-time');time.dataset.time='';listen.append(time);
        }else listen.append(make('span','bgml-unavailable','—'));
        const price=make('a','bgml-price',record.price);price.href=record.href;price.append(make('span','',document.documentElement.lang.startsWith('en')?'View details':'詳細を見る'));
        row.append(art,info,listen,price);return row;
      });
      // Cancel old carousel momentum before replacing a page; restore snapping after layout.
      cancelAnimationFrame(this.railResetFrame);
      this.tracks.style.scrollSnapType='none';
      this.tracks.scrollTo({left:0,top:0,behavior:'instant'});
      this.tracks.replaceChildren(...this.rows);
      this.tracks.scrollTo({left:0,top:0,behavior:'instant'});
      this.railResetFrame=requestAnimationFrame(()=>{
        const left=this.current&&this.isHorizontal()?this.tracks.scrollLeft+this.current.getBoundingClientRect().left+this.current.getBoundingClientRect().width/2-this.tracks.getBoundingClientRect().left-this.tracks.clientWidth/2:0;
        this.tracks.scrollTo({left,top:0,behavior:'instant'});
        this.tracks.style.removeProperty('scroll-snap-type');
      });this.playable=this.rows.filter(row=>row.dataset.url);this.registerRows(this.rows);this.syncButtons();
    }
    registerRows(rows) {
      const signal = (this.rowController || this.controller).signal;
      rows.forEach(row => {
        const data = row.querySelector('[data-peaks]');
        const peaks = data ? JSON.parse(data.dataset.peaks) : [];
        if (data) row.dataset.duration = data.dataset.duration;
        const scale = data ? Number(data.dataset.waveScale || 1) : 1;
        const heights = peaks.map(peak => Math.max(0.25, Number(peak) / scale * 30));
        const upper = heights.map((height, i) => `${(i * 960 / (peaks.length-1)).toFixed(2)},${(32-height).toFixed(2)}`);
        const lower = heights.map((height, i) => `${(i * 960 / (peaks.length-1)).toFixed(2)},${(32+height).toFixed(2)}`).reverse();
        const path = peaks.length > 1 ? 'M' + upper.join('L') + 'L' + lower.join('L') + 'Z' : 'M0 31.75H960V32.25H0Z';
        row.querySelectorAll('.bgml-wave path').forEach(node => node.setAttribute('d', path));
        this.paint(row, 0, Number(row.dataset.duration));
        const button = row.querySelector('[data-play]');
        if (button) button.addEventListener('click', () => {
          if (this.current === row) this.toggle();
          else this.select(row, true);
        }, {signal});
        const wave = row.querySelector('.bgml-wave');
        if (wave) wave.addEventListener('pointermove', event => {
          if (event.pointerType === 'touch') return;
          const rect = wave.getBoundingClientRect();
          wave.style.setProperty('--wave-hover-x', Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100)) + '%');
        }, {signal});
        const seek = row.querySelector('[data-seek]');
        if (seek) seek.addEventListener('input', () => {
          const fraction = Number(seek.value) / 100;
          if (this.current !== row) this.select(row, true);
          if (Number.isFinite(this.audio.duration)) this.audio.currentTime = this.audio.duration * fraction;
          else this.pendingSeek = fraction;
          this.paint(row, fraction * Number(row.dataset.duration), Number(row.dataset.duration));
        }, {signal});
      });
    }
    disconnectedCallback() {
      if (!this.controller) return;
      this.revision++;
      this.controller.abort();
      this.rowController?.abort();
      this.pausePlayback();
      this.audio.removeAttribute('src');
      this.audio.load();
      this.controller = null;
    }
    time(seconds) {
      return Number.isFinite(seconds) && seconds >= 0 ? Math.floor(seconds/60) + ':' + String(Math.floor(seconds%60)).padStart(2,'0') : '--:--';
    }
    paint(row, time, duration) {
      const percent = Number.isFinite(duration) && duration > 0 ? Math.min(100, Math.max(0, time/duration*100)) : 0;
      const seek = row.querySelector('[data-seek]');
      if (seek) {seek.value = percent;seek.setAttribute('aria-valuetext', this.time(time) + ' / ' + this.time(duration));}
      const progress = row.querySelector('.bgml-wave-progress');
      if (progress) progress.style.clipPath = `inset(0 ${100-percent}% 0 0)`;
      const label = row.querySelector('[data-time]');
      if (label) label.textContent = this.time(time) + ' / ' + this.time(duration);
    }
    select(row, play) {
      if (!row) return;
      if (this.current !== row) {
        this.revision++;
        this.pausePlayback();
        if (this.current) this.paint(this.current, 0, Number(this.current.dataset.duration));
        this.current = row;
        this.pendingSeek = null;
        this.audio.src = row.dataset.url;
        this.audio.load();
        this.dock.hidden = false;
        this.querySelector('[data-current-title]').textContent = row.dataset.title;
        this.rows.forEach(item => {
          item.classList.toggle('is-current', item === row);
          if (item === row) item.setAttribute('aria-current','true');
          else item.removeAttribute('aria-current');
        });
        this.status.textContent = this.labels.selected + ': ' + row.dataset.title;
        this.syncButtons();
      }
      if (play) this.play();
    }
    play() {
      if (!this.current) return;
      this.wantsPlayback = true;
      this.playbackFailed = false;
      this.retryCount = 0;
      if (this.audio.error) this.audio.load();
      this.requestPlayback();
    }
    clearRecovery() {
      clearTimeout(this.recoveryTimer);
      this.recoveryTimer = null;
    }
    armRecovery() {
      if (this.recoveryTimer !== null || !this.wantsPlayback) return;
      const revision = this.revision;
      this.recoveryTimer = setTimeout(() => {
        this.recoveryTimer = null;
        this.recover(revision);
      }, 8000);
    }
    pausePlayback() {
      this.wantsPlayback = false;
      this.playbackFailed = false;
      this.playRequest++;
      this.clearRecovery();
      this.audio.pause();
      this.status.textContent = '';
      this.syncButtons();
    }
    failPlayback() {
      this.pausePlayback();
      this.playbackFailed = true;
      this.status.textContent = this.current.dataset.title + ': ' + this.labels.error;
      this.syncButtons();
    }
    recover(revision) {
      if (revision !== this.revision || !this.isConnected || !this.wantsPlayback) return;
      this.clearRecovery();
      if (this.retryCount >= 1) { this.failPlayback(); return; }
      this.retryCount++;
      this.playRequest++;
      if (Number.isFinite(this.audio.duration) && this.audio.duration > 0 && this.audio.currentTime > 0) {
        this.pendingSeek = this.audio.currentTime / this.audio.duration;
      }
      this.audio.load();
      this.requestPlayback();
    }
    requestPlayback() {
      const revision = this.revision;
      const request = ++this.playRequest;
      document.querySelectorAll('audio,video').forEach(media => {if (media !== this.audio) media.pause();});
      this.status.textContent = this.labels.loading + ': ' + this.current.dataset.title;
      this.armRecovery();
      this.audio.play().catch(error => {
        if (revision !== this.revision || request !== this.playRequest || !this.isConnected || !this.wantsPlayback) return;
        if (error.name === 'NotAllowedError') this.failPlayback();
        else this.recover(revision);
      });
    }
    toggle() { if (this.wantsPlayback || !this.audio.paused) this.pausePlayback(); else this.play(); }
    move(direction, play = this.wantsPlayback || !this.audio.paused, repeated = false) {
      const index = this.current ? this.playable.indexOf(this.current) + direction : 0;
      if (index >= 0 && index < this.playable.length) {
        this.select(this.playable[index], play);
        if (this.isHorizontal()) this.reveal();
      } else if (this.current && !repeated) {
        this.closest('bgm-library-browser')?.moveTrackPage?.(direction, play);
      }
    }
    isHorizontal() {
      return matchMedia('(max-width:749px)').matches && getComputedStyle(this.tracks).display === 'flex';
    }
    reveal() {
      if (this.current && this.isHorizontal()) {
        this.tracks.scrollBy({left:this.current.getBoundingClientRect().left+this.current.getBoundingClientRect().width/2-this.tracks.getBoundingClientRect().left-this.tracks.clientWidth/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        return;
      }
      if (this.current) this.current.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    syncButtons() {
      this.rows.forEach(row => {
        const button = row.querySelector('[data-play]');
        if (!button) return;
        const playing = row === this.current && !this.audio.paused;
        button.querySelector('span').innerHTML = playing ? "<svg aria-hidden=\"true\" viewBox=\"0 0 24 24\" width=\"22\" height=\"22\" fill=\"currentColor\"><path d=\"M6 4h4v16H6zM14 4h4v16h-4z\"/></svg>" : "<svg aria-hidden=\"true\" viewBox=\"0 0 24 24\" width=\"22\" height=\"22\" fill=\"currentColor\"><path d=\"M7 4v16l13-8z\"/></svg>";
        button.setAttribute('aria-label', (playing ? this.labels.pause : this.labels.play) + ': ' + row.dataset.title);
        row.classList.toggle('is-playing', playing);
      });
      const toggle = this.querySelector('[data-toggle]');
      toggle.innerHTML = this.audio.paused ? "<svg aria-hidden=\"true\" viewBox=\"0 0 24 24\" width=\"22\" height=\"22\" fill=\"currentColor\"><path d=\"M7 4v16l13-8z\"/></svg>" : "<svg aria-hidden=\"true\" viewBox=\"0 0 24 24\" width=\"22\" height=\"22\" fill=\"currentColor\"><path d=\"M6 4h4v16H6zM14 4h4v16h-4z\"/></svg>";
      toggle.setAttribute('aria-label', this.audio.paused ? this.labels.play : this.labels.pause);
      const index = this.playable.indexOf(this.current);
      const browser = this.closest('bgm-library-browser');
      this.querySelector('[data-prev]').disabled = index < 0 || (index === 0 && browser?.adjacentTrackPage?.(-1) == null);
      this.querySelector('[data-next]').disabled = index < 0 || (index >= this.playable.length - 1 && browser?.adjacentTrackPage?.(1) == null);
    }
    setView(view) {
      this.dataset.view = view === 'grid' ? 'grid' : 'list';
      try {sessionStorage.setItem('bgml-view',this.dataset.view)} catch {}
      this.querySelectorAll('[data-view-button]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.viewButton === this.dataset.view)));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-made-service-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const link=event.target.closest('.cmg-service-details a[href^="#cmr-price-"]');if(!link)return;const target=document.getElementById(link.hash.slice(1));if(target)target.open=true;});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('article-link-copy')) {
  customElements.define('article-link-copy', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelector('button').addEventListener('click', async () => {
        const button = this.querySelector('button');
        const status = this.querySelector('[role="status"]');
        clearTimeout(this.timer);
        try {
          await navigator.clipboard.writeText(button.dataset.url);
          status.textContent = button.dataset.success;
        } catch {
          status.textContent = button.dataset.error;
        }
        this.timer = setTimeout(() => { status.textContent = ''; }, 3500);
      });
    }
    disconnectedCallback() { clearTimeout(this.timer); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
